import { ImageCheck } from "Explore/Components";
import { ImageCheckType } from "Explore/Config/ImageType";
import { useNavigate } from "react-router-dom";
import styles from "./OtherProfile.module.scss";

const OtherProfile = ({ item, index, callback = null }) => {
  const navigate = useNavigate();
  return (
    <div className={styles["profile"]} key={index}>
      <div className={styles["info"]}>
        <ImageCheck
          url={item?.photo}
          alt={"avatar"}
          type={ImageCheckType.FACULTY_AVATAR}
        />
        <div className={styles["title"]}>
          <p className={styles["title-name"]}>{item.name}</p>
          <p className={styles["title-institution"]}>
            {item.department.inst_name}
          </p>
          <p className={styles["title-position"]}>{item.position}</p>
        </div>
      </div>
      <div className={styles["citation"]}>
        <p>Citation count: {item.citation_count}</p>
        <div className={styles["button"]}>
          <button
            onClick={() => {
              navigate(`/explore/faculty/${item.explore_slug || item.id}`);
              if (callback) {
                callback();
              }
            }}
          >
            Detail
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtherProfile;
